export enum SectionNames {
  TLDR = 'tldr',
  BODY = 'body',
  TITLE = 'title',
  VIDEO = 'video',
  AVATAR = 'avatar',
  COMMENTS = 'comments',
  PURCHASE = 'purchase',
  REACTIONS = 'reactions',
  IMAGE_TITLE = 'imageTitle',
  SOCIAL_MEDIA = 'socialMedia',
  COLLAPSE_BTN = 'collapseButton',
  RELATED_GROUPS = 'relatedGroups',
  PRODUCT_CAROUSEL = 'productCarousel',
}
